export default [
  {
    path: '/workspace-admin',
    name: 'workspace-admin',
    component: () => import('@/views/workspace-admin/WorkspaceAdmin.vue'),
    meta: {
      title: 'Workspace Admin',
      requiresAuth: true,
    },
  },
]
